export const DocTypes = [
  {
    name: "AccountDocumentation",
    Id: "1"
  },
  {
    name: "FeesAndCommissions",
    Id: "2"
  },
  {
    name: "Complaints",
    Id: "3"
  },
  {
    name: "RegulatoryRequests",
    Id: "4"
  },
  {
    name: "Other",
    Id: "5"
  },
  {
    name: "ACHInstructions",
    Id: "6"
  },
  {
    name: "Breakdown",
    Id: "7"
  },
  {
    name: "ECPForm",
    Id: "8"
  },
  {
    name: "SecurityAgreement",
    Id: "9"
  },
  {
    name: "TaxForm",
    Id: "10"
  },
  {
    name: "LEIAgreement",
    Id: "11"
  },
  {
    name: "TradingPlatformSetups",
    Id: "12"
  },
  {
    name: "NZXDisclosure",
    Id: "13"
  },
  {
    name: "TMXDisclosure",
    Id: "14"
  },
  {
    name: "FinancialStatements",
    Id: "15"
  },
  {
    name: "AddressChange",
    Id: "16"
  },
  {
    name: "CloseAccount",
    Id: "17"
  },
  {
    name: "WireTransferInstructions",
    Id: "18"
  },
  {
    name: "AuditConfirmations",
    Id: "19"
  },
  {
    name: "InterestRequestForm",
    Id: "20"
  },
  {
    name: "FundingIssues",
    Id: "21"
  },
  {
    name: "Guarantee",
    Id: "22"
  },
  {
    name: "SupportDesk",
    Id: "23"
  },
  {
    name: "VirtualCurrencyDisclosure",
    Id: "24"
  },
  {
    name: "MTLDisclosure",
    Id: "25"
  }
];
